<template>
  <!-- X days -->
  <v-row class="my-0">
    <v-col class="py-3 pr-0">
      <v-card variant="flat" density="compact">
        <v-card-title class="pa-0" style="font-size: 12px; font-weight: 400">
          {{ $t("activeTimePeriod") }}:
        </v-card-title>
        <v-card-text class="py-0">
          <v-row class="ma-0">
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("mon")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-mon"
                    v-model="activeTimePeriod[0]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("tue")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-tue"
                    v-model="activeTimePeriod[1]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("wed")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-wed"
                    v-model="activeTimePeriod[2]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("thu")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-thu"
                    v-model="activeTimePeriod[3]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("fri")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-fri"
                    v-model="activeTimePeriod[4]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("sat")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-sat"
                    v-model="activeTimePeriod[5]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="pa-1">
              <v-row class="ma-0">
                <v-col class="pa-1" style="text-align: center">{{
                  $t("sun")
                }}</v-col>
              </v-row>
              <v-row class="ma-0">
                <v-col class="pa-1">
                  <v-checkbox
                    density="compact" 
                    color="primary"
                    class="vertical-checkbox mx-2"
                    false-icon="ecc:ecc-D-QuadOFF" 
                    true-icon="ecc:ecc-D-QuadON"
                    data-qa="notification-time-sun"
                    v-model="activeTimePeriod[6]"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { dataStore } from "../../stores/data";
import AnimatedButton from "../UIComponents/AnimatedButton.vue";
import { defineComponent, nextTick } from "vue";
import {
  TriggerEmailEventContentDTO,
  TriggerTeamsEventContentDTO,
  TriggerTelegramEventContentDTO,
  TriggerWebhookEventContentDTO,
} from "./type.util";

export default defineComponent({
  name: "TriggerComponentModelPathMatcher",
  components: {
    AnimatedButton,
  },
  data() {
    return {
      dataStore: dataStore(),
      activeTimePeriod: [true, true, true, true, true, true, true],
    };
  },
  props: {
    config: {
      type: Object as () =>
        | TriggerEmailEventContentDTO
        | TriggerWebhookEventContentDTO
        | TriggerTeamsEventContentDTO
        | TriggerTelegramEventContentDTO,
      default: null,
    },
  },
  methods: {
    computeXdays(): void {
      for (let i = 0; i < 7; i++) {
        this.activeTimePeriod[i] =
          this.config.xdays?.indexOf("" + i) > -1 ? true : false;
      }
    },
     initConfig(): void {
      this.computeXdays();
    },
  },
  watch: {
    config: function (config) {
      this.initConfig();
    },
    activeTimePeriod: {
      handler: function (atp): void {
        nextTick(() => {
          const positions: number[] = [];
          if (this.activeTimePeriod.every(a => a === false)) {
            this.activeTimePeriod = [true, true, true, true, true, true, true];
          }
          for (let i = 0; i < this.activeTimePeriod.length; i++) {
            if (this.activeTimePeriod[i]) {
              positions.push(i);
            }
          }
          this.config.xdays = positions.join(", ");
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.initConfig();
  }
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
</style>
